module.exports = __webpack_public_path__ + "977f3f5274ffd47e63227189a65c64f5.svg";